import {
  CALC_FREE_DATA,
  CALC_FREE_LIST,
  CALC_GET_STATUS_LIST,
  CALC_GET_ROUTE,
  CALC_GET_LIST,
  CALC_GET, // Получение рецептуры, по передаваемому идентификатору
  CALC_SET_FILTER,
  CALC_SET_CURRENT,
  CALC_CREATE,
  CALC_UPDATE,
  CALC_POST_STATE,
  CALC_ADD_FILE,
  CALC_DEL_FILE
} from '../actions/calculations'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import axios from 'axios'
const state = {
  currentCalculation: {},
  calcList: [],
  calcStatesList: [],
  currentCalcFilter: { DS_ID: '-5', FT_ID: '-5' }
}

const getters = {
  getCurrentCalcState: state => state.currentCalculation.DS_ID,
  getCurrentCalcID: state => state.currentCalculation.CALC_UUID,
  getCurrentCalculation: state => state.currentCalculation,
  getCurrentCalculationFiles: state => {
    if (typeof state.currentCalculation.FILE_LIST !== 'undefined') {
      return state.currentCalculation.FILE_LIST
    } else {
      return []
    }
  },
  getCurrentCalculationsList: state => state.calcList,
  getCalculationsStatesList: state => state.calcStatesList,
  getCurrentCalculationsFilter: state => state.currentCalcFilter,
  getCurrentCalculationsStateFilter: state => state.currentCalcFilter.DS_ID
}

const actions = {
  [CALC_FREE_DATA]: ({ commit }) =>
    new Promise((resolve) => {
      commit(CALC_FREE_DATA)
      resolve('success')
    }),

  [CALC_FREE_LIST]: ({ commit }) =>
    new Promise((resolve) => {
      commit(CALC_FREE_LIST)
      resolve('success')
    }),

  [CALC_GET_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_GET_STATUS_LIST', topic: 'Загрузка списка статусов расчётов', error: null })
      axios({ url: '/api/org/receptures/calcStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'CALC_GET_STATUS_LIST' })
            commit(CALC_GET_STATUS_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            console.log('EVENT status list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'CALC_GET_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_GET_STATUS_LIST', result: 'Получение списка возможных статусов расчёта: ошибка сервера' })
          reject(err)
        })
    }),

  [CALC_GET_ROUTE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_GET_ROUTE', topic: 'Получение истории', error: null })
      axios({ url: '/api/org/calculations/getCalcRoute.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CALC_GET_ROUTE' })
          } else {
            dispatch(UI_ERROR, { action: 'CALC_GET_ROUTE', result: 'Ошибка получения истории: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_GET_ROUTE', result: 'Получение истории: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_GET_LIST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_GET_LIST', topic: 'Загрузка списка смесей', error: null })
      console.log('Called action CALC_GET_LIST, current filter is  ', state.currentCalcFilter)
      const filterSet = !(state.currentCalcFilter.DS_ID === null)
      if (!filterSet) {
        reject(new Error('Не установлен фильтр состояний'))
        dispatch(UI_ERROR, { action: 'CALC_GET_LIST', result: 'Не установлен фильтр состояний' })
        return
      }
      axios({ url: '/api/org/calculations/calcGetList.php', data: { ...state.currentcalcFilter, ...params }, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CALC_GET_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CALC_GET_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CALC_GET_LIST', result: 'Ошибка получения списка расчётов ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_GET_LIST', result: 'Получение списка расчётов: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_GET]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_GET', topic: 'Загрузка расчёта', error: null })
      axios({ url: '/api/org/calculations/getCalculation.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'CALC_GET' })
            commit(CALC_SET_CURRENT, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CALC_GET', result: 'Ошибка получения данных: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_GET', result: 'Получение данных: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_SET_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      console.log('Called action CALC_SET_FILTER] ', filterItem)
      dispatch(UI_REQUEST, { action: 'CALC_SET_FILTER', topic: 'Установка фильтра расчётов', error: null })
      if (filterItem.DS_ID || filterItem.FT_ID) {
        if (filterItem.DS_ID !== state.currentCalcFilter.DS_ID || filterItem.FT_ID !== state.currentCalcFilter.FT_ID) {
          commit(CALC_SET_FILTER, filterItem)
          dispatch(CALC_GET_LIST)
            .then(resp => {
              dispatch(UI_SUCCESS, { action: 'CALC_SET_FILTER' })
              resolve(resp)
            })
            .catch((err) => {
              dispatch(UI_ERROR, { action: 'CALC_SET_FILTER', result: 'Установка фильтра расчётов: ошибка сервера' })
              reject(err)
            })
        } else {
          dispatch(UI_SUCCESS, { action: 'CALC_SET_FILTER' })
          resolve(filterItem)
        }
      } else {
        commit(CALC_SET_FILTER, filterItem)
        dispatch(UI_SUCCESS, { action: 'CALC_SET_FILTER' })
        resolve(filterItem)
      }
    }),

  [CALC_SET_CURRENT]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve) => {
      console.log('Called action CALC_SET_CURRENT ', requestItem)
      dispatch(UI_REQUEST, { action: 'CALC_SET_CURRENT', topic: 'Установка активного расчёта', error: null })
      if (requestItem) {
        if (requestItem.ULF_ID !== state.currentRecepture.ULF_ID) {
          console.log('Setting new current calculation', requestItem)
          commit(CALC_SET_CURRENT, requestItem)
        }
      } else {
        commit(CALC_SET_CURRENT, {})
      }
      dispatch(UI_SUCCESS, { action: 'CALC_SET_CURRENT' })
      resolve()
    }),

  [CALC_CREATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_CREATE', topic: 'Создание заголовка расчёта', error: null })
      axios({ url: '/api/org/calculations/calcAdd.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CALC_CREATE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CALC_CREATE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CALC_CREATE', result: 'Создание заголовка расчёта: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_CREATE', result: 'Создание заголовка расчёта: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_UPDATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_UPDATE', topic: 'Обновление заголовка расчёта', error: null })
      axios({ url: '/api/org/calculations/calcUpdate.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CALC_UPDATE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CALC_UPDATE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CALC_UPDATE', result: 'Обновление заголовка рецептуры: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_UPDATE', result: 'Обновление заголовка рецептуры: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_POST_STATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_POST_STATE', topic: 'Изменение состояния расчёта', error: null })
      axios({ url: '/api/org/calculations/calcPostState.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CALC_POST_STATE, params)
            resolve(resp.data)
            dispatch(UI_SUCCESS, { action: 'CALC_POST_STATE' })
          } else {
            dispatch(UI_ERROR, { action: 'CALC_POST_STATE', result: 'Ошибка отправки запроса : ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_POST_STATE', result: 'Ошибка отправки запроса: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_ADD_FILE,', topic: 'Добавление файла к расчёту', error: null })
      axios({ url: '/api/org/calculations/calcUploadDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CALC_ADD_FILE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CALC_ADD_FILE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'CALC_ADD_FILE', result: 'Ошибка добавления файла в расчёт: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_ADD_FILE', result: 'Добавление райла в расчёт: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [CALC_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'CALC_DEL_FILE', topic: 'Удаление файла из расчёта', error: null })
      axios({ url: '/api/org/calculations/calcDeleteDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(CALC_DEL_FILE, params)
            resolve(resp.data.data)
            dispatch(UI_SUCCESS, { action: 'CALC_DEL_FILE' })
          } else {
            dispatch(UI_ERROR, { action: 'CALC_DEL_FILE', result: 'Удаление файла из расчёта: ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'CALC_DEL_FILE', result: 'Удаление файла из расчёта: ошибка сервера' })
          reject(new Error(err))
        })
    })
}

const mutations = {

  [CALC_FREE_DATA]: state => {
    state.currentCalculation = {}
    state.calcList.splice(0, state.calcList.length)
    state.calcStatesList.splice(0, state.calcStatesList.length)
    state.currentCalcFilter = { DS_ID: '-5' }
  },

  [CALC_FREE_LIST]: state => {
    state.calcList.splice(0, state.calcList.length)
  },

  [CALC_GET_STATUS_LIST]: (state, resp) => {
    console.log('CALC_GET_STATUS_LIST mutation initiated, ', resp)
    state.calcStatesList.splice(0, state.calcStatesList, ...resp)
    state.currentCalcFilter.DS_ID = state.calcStatesList[0].DS_ID
  },

  [CALC_GET_LIST]: (state, resp) => {
    console.log('CALC_GET_LIST mutation initiated, ', resp)
    state.calcList.splice(0, state.calcList.length, ...resp)
    state.currentCalculation = []
  },
  [CALC_SET_FILTER]: (state, resp) => {
    console.log('CALC_SET_FILTER mutation initiated, ', resp)
    state.currentCalcFilter = { ...state.currentCalcFilter, ...resp }
  },

  [CALC_SET_CURRENT]: (state, resp) => {
    console.log('CALC_SET_CURRENT mutation initiated, ', resp)
    state.currentCalculation = resp
  },

  [CALC_CREATE]: (state, calcItem) => {
    console.log('CALC_CREATE mutation initiated', calcItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    // eslint-disable-next-line eqeqeq
    if (state.currentCalcFilter.DS_ID == calcItem.STATE.DS_ID || state.currentCalcFilter.DS_ID == -5) {
      // Если да, то добавляем новый запрос в глобальный список запросов
      state.calcList.push(calcItem)
    }
    state.currentCalculation = calcItem
  },

  [CALC_UPDATE]: (state, calcItem) => {
    console.log('CALC_UPDATE mutation initiated', calcItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    // eslint-disable-next-line eqeqeq
    if (state.currentCalcFilter.DS_ID == calcItem.STATE.DS_ID || state.currentCalcFilter.DS_ID == -5) {
      const idx = state.calcList.findIndex(itm => itm.CALC_UUID === calcItem.CALC_UUID)
      if (idx >= 0) {
        state.calcList.splice(idx, 1, calcItem)
      } else {
        state.calcList.push(calcItem)
      }
      state.currentCalculation = calcItem
    }
    state.currentCalculation = calcItem
  },

  [CALC_POST_STATE]: (state, resp) => {
    console.log('CALC_POST_STATE mutation called. RESP is ', resp)
    const calcItemIdx = state.calcList.findIndex(calc => calc.CALC_UUID === resp.CALC_UUID)
    if (state.currentCalcFilter.DS_ID !== resp.DS_ID && state.currentCalcFilter.DS_ID !== '-5') {
      if (calcItemIdx >= 0) state.calcList.splice(calcItemIdx, 1)
    } else {
      if (calcItemIdx >= 0) {
        state.calcList[calcItemIdx].STATE.DS_ID = resp.DS_ID
        state.calcList[calcItemIdx].STATE.DS_NAME = resp.DS_NAME
      }
    }
  },

  [CALC_ADD_FILE]: (state, responce) => {
    console.log('CALC_ADD_FILE mutation called, payload ', responce)
    // state.currentEvent.FILE_LIST.push(responce)
  },
  [CALC_DEL_FILE]: (state, responce) => {
    console.log('CALC_DEL_FILE mutation called, payload ', responce)
    // const index = state.currentEvent.FILE_LIST.findIndex(itm => itm.DD_ID === responce.DD_ID)
    // state.currentEvent.FILE_LIST.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
